import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "data-table" }
const _hoisted_2 = ["onBlur"]
const _hoisted_3 = {
  key: 0,
  class: "readonly-cell"
}
const _hoisted_4 = ["value", "onInput"]


export default /*@__PURE__*/_defineComponent({
  __name: 'TableBlock',
  props: {
    block: {},
    pageIndex: {},
    blockIndex: {}
  },
  emits: ["update", "contentEdit"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

function updateTitle(event: Event) {
  const target = event.target as HTMLElement;
  emit("update", { title: target.innerText });
  emit("contentEdit");
}

function updateColumnLabel(colIndex: number, event: Event) {
  const target = event.target as HTMLElement;
  const newColumns = [...props.block.data.columns];
  newColumns[colIndex].label = target.innerText;
  emit("update", { columns: newColumns });
  emit("contentEdit");
}

function updateCell(rowIndex: number, columnKey: string, event: Event) {
  const target = event.target as HTMLInputElement;
  const newData = [...props.block.data.data];
  newData[rowIndex][columnKey] = target.value;
  emit("update", { data: newData });
  emit("contentEdit");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "table-block",
    style: _normalizeStyle(__props.block.style)
  }, [
    _createElementVNode("h3", {
      contenteditable: "true",
      onBlur: updateTitle
    }, _toDisplayString(__props.block.data.title), 33),
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.block.data.columns, (column, colIndex) => {
            return (_openBlock(), _createElementBlock("th", {
              key: column.key,
              contenteditable: "true",
              onBlur: ($event: any) => (updateColumnLabel(colIndex, $event))
            }, _toDisplayString(column.label), 41, _hoisted_2))
          }), 128))
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.block.data.data, (row, rowIndex) => {
          return (_openBlock(), _createElementBlock("tr", { key: rowIndex }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.block.data.columns, (column) => {
              return (_openBlock(), _createElementBlock("td", {
                key: column.key
              }, [
                (!column.editable)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(row[column.key]), 1))
                  : (_openBlock(), _createElementBlock("input", {
                      key: 1,
                      value: row[column.key],
                      onInput: ($event: any) => (updateCell(rowIndex, column.key, $event)),
                      class: "editable-cell"
                    }, null, 40, _hoisted_4))
              ]))
            }), 128))
          ]))
        }), 128))
      ])
    ])
  ], 4))
}
}

})